export const COMMENTS_APP_DATA_LOADING_EVENT = "commentsAppDataLoading";
export const COMMENTS_APP_FILTERS_APPLIED_EVENT = "commentsAppFiltersApplied";
export const COMMENTS_APP_FILTERS_CANCEL_EVENT = "commentsAppFiltersCancel";
export const MIN_COMMENTS_COUNT = 10;

export const COMMENTS_TRENDS = {
  FAVORABILITY: "favorability",
  SENTIMENT: "sentiment",
};

export const THEME_SORT_BY = {
  COMMENTS: "comments",
  FAVORABILITY: "favorability",
  UNFAVORABILITY: "unfavorability"
};
